import { Underline } from 'almanac-ui/icons/16'
import { useUnderlineToggle } from 'common/Prose/Toolbar/hooks/useUnderlineToggle'
import { InlineFormatDropdownMenuItem } from 'components/InlineFormatBar/components/InlineFormatDropdownMenuItem/InlineFormatDropdownMenuItem'
import { observer } from 'mobx-react-lite'
import { EditorView } from 'prosemirror-view'

export const UnderlineInlineFormatButton = observer(
  ({ view, callback }: { view: EditorView; callback?: () => void }) => {
    const { active, disabled, handleClick } = useUnderlineToggle(view)

    return (
      <InlineFormatDropdownMenuItem
        key={'underline'}
        onClick={() => {
          handleClick()
          callback?.()
        }}
        active={active}
        isDisabled={disabled}
        icon={<Underline />}
        label="Underline"
      />
    )
  },
)
